import { Component } from '@angular/core';

@Component({
    selector: 'fi-page-collapsable-content-title',
    template: '<ng-content></ng-content>',
    standalone: false,
})
export class FiPageCollapsableContentTitleComponent {}
